/**
 * 用户每个项数据组件
 */
import React, { useMemo, useCallback } from 'react';
import { Tooltip } from 'antd';
import { getIsSelf } from './common';
import Mobile from './Mobile';
import { UserCardAction, UserCardType } from './UserCardType';
import UserDeptTitle from './UserDeptTitle';
import Remark from './Remark';
import IconFont from '../IconFont';
function UserInfoItem(props) {
    var _a, _b, _c;
    var user = props.user, cardType = props.cardType, analysisLog = props.analysisLog, currentUser = props.currentUser, remarkSet = props.remarkSet, showTag = props.showTag, notPersonalCalendar = props.notPersonalCalendar, examineMobileRecord = props.examineMobileRecord, webExamineMobileRecord = props.webExamineMobileRecord, triggerEvent = props.triggerEvent, hideUserCardModal = props.hideUserCardModal, currentPage = props.currentPage;
    var isSelf = getIsSelf(currentUser, user);
    var isRobot = useMemo(function () { var _a; return (_a = user.userId) === null || _a === void 0 ? void 0 : _a.startsWith("robot_"); }, [user]);
    var fields = useMemo(function () {
        if (!user) {
            return null;
        }
        return user.fields
            .filter(function (item) {
            return item.hide === 0 &&
                [
                    'avatar',
                    'name',
                    'signature',
                    'sex',
                    'station',
                    'e_dept_full_name',
                    'e_position'
                    // 'workStatus',
                ].indexOf(item.key) < 0 &&
                !!item.val;
        })
            .sort(function (a, b) { return a.index - b.index; });
    }, [user]);
    var showCalendar = useCallback(function () {
        var _a;
        // 展示用户日历
        props.onActionClick({ type: UserCardAction.Chat, data: user });
        (_a = props.triggerEvent) === null || _a === void 0 ? void 0 : _a.call(props, 'showCalendar', user);
    }, [user, props]);
    var showLine = useMemo(function () {
        var main = user.mainTitleDeptInfo, part = user.partTimeTitleDeptInfo;
        return (main === null || main === void 0 ? void 0 : main.deptId) || (part && part.length > 0 && part[0].deptId);
    }, [user]);
    var itemNode = useCallback(function (item) {
        var _a, _b;
        if (item.key === 'mobile') {
            return (React.createElement(Mobile, { user: user, isSelf: isSelf, cardType: cardType, analysisLog: analysisLog, currUser: currentUser, examineMobileRecord: examineMobileRecord, webExamineMobileRecord: webExamineMobileRecord }));
        }
        return (React.createElement("div", { className: "usercard-item-content" },
            React.createElement("h5", { className: "usercard-item-title" }, item.name),
            item.key === 'workStatus' ? (React.createElement("p", { className: "usercard-item-desc" },
                React.createElement("img", { src: (_a = JSON.parse(item.val || '')) === null || _a === void 0 ? void 0 : _a.icon, style: {
                        width: '20px',
                        verticalAlign: 'sub',
                        marginRight: '5px'
                    } }), (_b = JSON.parse(item.val || '')) === null || _b === void 0 ? void 0 :
                _b.workStatus)) : (React.createElement("p", { className: "usercard-item-desc" }, item.val))));
    }, [
        analysisLog,
        cardType,
        currentUser,
        examineMobileRecord,
        isSelf,
        user,
        webExamineMobileRecord
    ]);
    if (cardType === UserCardType.Group || !user) {
        return null;
    }
    if (!(fields === null || fields === void 0 ? void 0 : fields.length) && !user.partTimeTitleDeptInfo) {
        return null;
    }
    if (isRobot) {
        return (React.createElement("div", { className: "me-user-card-item V2" },
            React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title" }, "\u5F00\u53D1\u8005"),
                React.createElement("p", { className: "usercard-item-desc" }, (_a = user.fields.find(function (e) { return e.key === 'developer'; })) === null || _a === void 0 ? void 0 : _a.val)),
            React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title" }, "\u7B80\u4ECB"),
                React.createElement("p", { className: "usercard-item-desc" }, (_b = user.fields.find(function (e) { return e.key === 'brief'; })) === null || _b === void 0 ? void 0 : _b.val))));
    }
    return (React.createElement(React.Fragment, null,
        ((_c = user === null || user === void 0 ? void 0 : user.partTimeTitleDeptInfo) === null || _c === void 0 ? void 0 : _c.length) ? (React.createElement("div", { className: "me-user-card-item V2" },
            React.createElement(UserDeptTitle, { currentPage: currentPage, userType: user === null || user === void 0 ? void 0 : user.userType, hideUserCardModal: hideUserCardModal, triggerEvent: triggerEvent, partTimeTitleDeptInfo: user.partTimeTitleDeptInfo }))) : null,
        React.createElement("div", { className: "me-user-card-item V2" },
            (fields || []).map(function (item, index) {
                var _a;
                if (item.key === 'workStatus' && !((_a = JSON.parse(item.val || '')) === null || _a === void 0 ? void 0 : _a.workStatus)) {
                    return null;
                }
                return (React.createElement("div", { key: item.key }, itemNode(item)));
            }),
            !isSelf && !notPersonalCalendar && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title" }, "\u65E5\u5386"),
                React.createElement("p", { className: "usercard-item-desc" },
                    React.createElement("span", { style: {
                            display: 'inline-block',
                            color: '#0073FF',
                            cursor: 'pointer',
                            userSelect: 'none'
                        }, onClick: showCalendar }, "\u67E5\u770B\u65E5\u5386")))),
            !isRobot && React.createElement(Remark, { user: user, cardType: cardType, currentUser: currentUser, analysisLog: analysisLog, remarkSet: remarkSet }),
            !isRobot && showTag && (React.createElement("div", { className: "usercard-item-content" },
                React.createElement("h5", { className: "usercard-item-title" }, "\u5206\u7EC4"),
                React.createElement("p", { className: "usercard-item-desc", onClick: props.handleAddTag },
                    React.createElement("div", { className: "flex", style: {
                            // paddingRight: 10,
                            // marginTop: -3,
                            alignItems: 'center',
                            cursor: 'pointer'
                        } },
                        user && user.tagInfoList && user.tagInfoList.length ? (React.createElement("div", { className: "tag-list" }, user.tagInfoList.map(function (tag) {
                            return (React.createElement(Tooltip, { title: tag.name, key: tag.tagId },
                                React.createElement("div", { className: "tag" }, tag.name)));
                        }))) : (React.createElement("span", { style: {
                                color: 'rgba(129, 135, 147, 0.5)',
                            } }, "\u9009\u62E9\u5206\u7EC4")),
                        React.createElement("span", { style: {
                                color: '#818793',
                                // marginTop: 4
                                fontSize: '20px',
                                marginLeft: '2px'
                            } },
                            React.createElement(IconFont, { type: "icona-statejiantou" })))))))));
}
export default UserInfoItem;
//# sourceMappingURL=UserInfoItem.js.map